var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCardMobile = function SvgCardMobile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 160 244",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#card-mobile_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M224.999 110.519a37.266 37.266 0 0 0-10.88-26.32 37.138 37.138 0 0 0-26.27-10.912h-24.904c5.018 7.315 2.265 18.644-6.891 23.933l-78.14 45.185H59.528v10.636L4.551 184.927v5.515l13.931 8.065a18.387 18.387 0 0 0 9.12 2.382h68.7c4.877 0 9.554-1.94 13.003-5.395a18.436 18.436 0 0 0 5.386-13.024v-2.832l27.581 15.868v5.327h-27.581v5.308l22.975 13.299 13.8-7.991a18.403 18.403 0 0 0 6.729-6.738 18.445 18.445 0 0 0 2.465-9.205v-26.503l64.339-37.27v21.308h-27.582v5.327l23.05 13.279 13.726-8.028a18.369 18.369 0 0 0 6.733-6.735 18.41 18.41 0 0 0 2.461-9.208v-18.757a18.404 18.404 0 0 0-11.353-17.005 18.323 18.323 0 0 0-7.035-1.395Zm-147.084 53.1v-10.578h18.388l-18.388 10.578Zm36.776-53.1L59.527 78.632v-5.346h87.67c1.88 0 3.708.62 5.2 1.767a8.556 8.556 0 0 1 2.691 10.062 8.549 8.549 0 0 1-3.622 4.134l-36.775 21.27Z",
    fill: "#9083E0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "card-mobile_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(0 .44)",
    d: "M0 0h160v243H0z"
  })))));
};
export default SvgCardMobile;